import { useMemo } from "react";
import { ProductTypeListModel, ProductTypeListProps } from "./ProductTypeList.componentModel";

export const useComponentData = (props: ProductTypeListProps) => {
  const componentData = useMemo(() => new ProductTypeListModel({ props }), [props]);

  return { componentData };
};
